<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="success"
          :to="{ name: 'departments-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>
    <b-card
      aria-hidden="true"
      :title="itemsData.name"
    >
      <b-card-text class="mb-2">
        Danh sách người dùng thuộc phòng ban
      </b-card-text>
      <!-- BODY -->
      <b-table
        ref="refListTable"
        class="table-responsive table-nowrap"
        :items="userItems"
        :fields="tableColumns"
        responsive="sm"
        show-empty
        empty-text="Không tìm thấy kết quả"
      >
        <!-- Column: Parent -->
        <template #cell(parent_id)="row">
          {{ row.item.parent ? row.item.parent.name : '' }}
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of })
            }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalEntries"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BCard, BCardText, BOverlay, BTable, BButton, BPagination,
} from 'bootstrap-vue'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter } from '@core/utils/utils';
import {
  required, alphaNumDot, max, integer,
} from '@validations';
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useDepartments from './useDepartments'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BCardText,
    BOverlay,
    BTable,
    BButton,
    BPagination,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      alphaNumDot,
      max,
      integer,
    }
  },
  setup() {
    const { route, router } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'departments-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const userItems = ref([])

    const {
      itemsData,
      currentPage,
      perPage,
      totalEntries,
      dataMeta,
    } = useDepartments();

    // Table Handlers
    const tableColumns = [
      { key: 'id', sortable: false, thAttr: { width: 40 } },
      {
        key: 'full_name',
        sortable: false,
        label: 'Tên',
      },
      {
        key: 'username',
        sortable: false,
        label: 'Tài khoản',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Số điện thoại',
      },
    ];

    loading.value = true;
    store.dispatch('departments/fetchDepartment', { id: id.value })
      .then(response => {
        if (response.status === 200) {
          itemsData.value = response.data.data
          itemsData.value.parent_id = itemsData.value.parent_id === null ? 0 : itemsData.value.parent_id;
          loading.value = false
          errorMessage.value = '';
        } else {
          errorMessage.value = response.message
          loading.value = false
        }
      })

    const fetchUser = () => {
      loading.value = true;
      store.dispatch('departments/fetchDepartmentUser', { id: id.value })
        .then(response => {
          if (response.status === 200) {
            userItems.value = response.data.data.data
            totalEntries.value = response.data.data.total
            loading.value = false
          } else {
            loading.value = false
          }
        })
    }

    watch([currentPage], () => {
      fetchUser();
    });

    fetchUser();

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemsData,
      userItems,
      tableColumns,
      dataMeta,
      totalEntries,
      perPage,
      currentPage,
    }
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
